module.exports = __webpack_public_path__ + "static/media/burger_background.083ee5ca.svg";